module.exports = __webpack_public_path__ + "media/content-creator/beauty-3-3ae685c8.png";